import { render, staticRenderFns } from "./MemberDomainProductPrices.vue?vue&type=template&id=1a72db94&scoped=true&"
import script from "./MemberDomainProductPrices.vue?vue&type=script&lang=js&"
export * from "./MemberDomainProductPrices.vue?vue&type=script&lang=js&"
import style0 from "./MemberDomainProductPrices.vue?vue&type=style&index=0&id=1a72db94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a72db94",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VRow,VTextField})
